import LightHeader from "components/Headers/LightHeader"
import Loading from "components/Modals/Loading"
import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Card, CardBody, CardHeader, Col, Container, Row, Button } from "reactstrap"
import api from "services/api"
import ReactBSAlert from "react-bootstrap-sweetalert"
import ServiceDeskTable from "components/Tables/admin/ServiceDeskTable"

import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import { transformNumberToCurency } from "utils/currencyHandling"
import { minutesToHours, hoursToMinutes } from "utils/timeHandling"
import ServiceDeskTableHeader from "components/TableHeaders/admin/ServiceDeskTableHeader"
import { data } from "jquery"
import moment from "moment"

export default function ServiceDesk(props) {
  const [loading, setloading] = useState(false)
  const [to, setTo] = useState(null)
  const [from, setFrom] = useState(null)

  const [alert, setAlert] = useState(null)
  const [contracts, setContracts] = useState([])

  const [filterOpen, setFilterOpen] = useState(true);
  const [filterFinished, setFilterFinished] = useState(false);

  const toggleFilter = (filterName) => {
    if (filterName === "filterOpen") setFilterOpen(!filterOpen);
    if (filterName === "filterFinished") setFilterFinished(!filterFinished);
  };

  const fetchContracts = useCallback(async () => {
    setloading(true)
    try {
      const [contractsResponse, pastDueResponse] = await Promise.all([
        api.post("contract/searchForServiceDeskReport", { dateTo: to, dateFrom: from }),
        api.post("pastDue/search", { dateTo: to, dateFrom: from })
      ])

      const enrichedContracts = contractsResponse.data.map(contract => {
        const clientPastDue = pastDueResponse.data.filter(
          ap => ap.customer?._id === contract.customer?._id && ap.deleted === "N"
        )
        return { ...contract, clientPastDue }
      })

      setContracts(enrichedContracts)

    } catch (error) {
      console.error("Ocorreu um erro")
    } finally {
      setloading(false)
    }
  }, [from, to])


  function hideAlert() {
    setAlert(null)
  }

  const parsedTableData = useMemo(() => {
    let total = {
      customer: "TOTAL",
      hourlyRate: null,
      maxCostHour: null,
      performedHours: 0,
      pastDueHours: 0,
      pastDueCost: 0,
      billedHours: 0,
      maximumCost: 0,
      performedCost: 0,
      difference: 0,
      status: "" 
    }

    const filteredContracts = contracts.filter((contract) => {
      const dateFromProjectInfo = contract.projectInfo && contract.projectInfo[0] ? contract.projectInfo[0].endDate : null;
      const dateDirect = contract.endDate;
      
      const finalEndDate = dateDirect || dateFromProjectInfo;
      
      const isFinished = !!(finalEndDate && finalEndDate !== "" && finalEndDate !== null);
      const isOpen = !isFinished;

      if (filterOpen && isOpen) return true;
      if (filterFinished && isFinished) return true;
      return false;
    });

    let parsed = filteredContracts.map((contract) => {
      let amount = 0; let hours = 0; let hoursMinutos = 0;
      for (let i = 0; i < contract.contractinstallments.length; i++) {
        let emissao = new Date(contract.contractinstallments[i].docDate)
        let dataDe = new Date(from + "T00:00:00.000Z")
        let dataAte = new Date(to + "T23:59:59.000Z")

        if (emissao >= dataDe && emissao <= dataAte && contract.contractinstallments[i].deleted === "N" && contract.contractinstallments[i].status === "I") {
          amount += contract.contractinstallments[i].amount;
          let hora = contract.contractinstallments[i].hours.split(':')
          hours += parseInt(hora[0])
          hoursMinutos += parseInt(hora[1])
        }
      }

      const custoMedioMinutos = amount / (hours + (hoursMinutos / 60)) || 0;
      let horasFaturadas = (contract.installmentsTotal?.totalTime || 0) / 60
      let maxCostHour = custoMedioMinutos * 0.4
      let maxCost = maxCostHour * (horasFaturadas || 0)
      const totalPastDueMinutes = contract.clientPastDue?.reduce((acc, curr) => acc + hoursToMinutes(curr.hours), 0) || 0
      const pastDueCost = (totalPastDueMinutes / 60) * maxCostHour
      const performedCost = contract.projectTotal?.performedCost || 0
      const finalDifference = maxCost - performedCost - pastDueCost

      total.maximumCost += maxCost
      total.performedCost += performedCost
      total.pastDueHours += totalPastDueMinutes
      total.pastDueCost += pastDueCost
      total.difference += finalDifference
      total.performedHours += contract.projectTotal?.totalTime || 0
      total.billedHours += horasFaturadas || 0

      const projectDate = (contract.projectInfo && contract.projectInfo[0] ? contract.projectInfo[0].endDate : null) || contract.endDate;
      const isProjectFinished = !!(projectDate && projectDate !== null);
      
      return {
        customer: contract.customer?.shortName || contract.customer?.fullName || "N/A",
        status: isProjectFinished ? "CONCLUÍDO" : "ABERTO",
        hourlyRate: transformNumberToCurency(custoMedioMinutos),
        maxCostHour: transformNumberToCurency(maxCostHour),
        performedHours: minutesToHours(contract.projectTotal?.totalTime || 0),
        pastDueHours: minutesToHours(totalPastDueMinutes),
        pastDueCost: transformNumberToCurency(pastDueCost),
        billedHours: minutesToHours(contract.installmentsTotal?.totalTime || 0),
        maximumCost: transformNumberToCurency(maxCost),
        performedCost: transformNumberToCurency(performedCost),
        difference: transformNumberToCurency(finalDifference),
      }
    })

    if (parsed.length > 0) {
      parsed.push({
        ...total,
        status: "TOTAL_ROW",
        maximumCost: transformNumberToCurency(total.maximumCost),
        performedCost: transformNumberToCurency(total.performedCost),
        pastDueCost: transformNumberToCurency(total.pastDueCost),
        difference: transformNumberToCurency(total.difference),
        billedHours: minutesToHours(total.billedHours * 60 ),
        performedHours: minutesToHours(total.performedHours),
        pastDueHours: minutesToHours(total.pastDueHours),
      })
    }
    return parsed
  }, [contracts, from, to, filterOpen, filterFinished])

  return (
    <>
      <LightHeader title="Análise Service Desk" parent="Relatórios" menuTitle="Análise Service Desk" />
      <Container className="mt--6" fluid style={{ overFlowY: "scroll" }}>
        <Row>
          <div className="col">
            <Card>
              <CardHeader>
                <ServiceDeskTableHeader
                  to={to}
                  from={from}
                  setTo={(value) => setTo(value)}
                  setFrom={(value) => setFrom(value)}
                  fetchContracts={() => fetchContracts()}
                />
                
                <Row className="mt-3">
                  <Col md="4">
                    <div className="d-flex" style={{ maxWidth: "260px" }}>
                      <Button
                        className="w-50 mr-1"
                        color={filterOpen ? "primary" : "secondary"}
                        outline={!filterOpen}
                        size="sm"
                        onClick={() => toggleFilter("filterOpen")}
                      >
                        {filterOpen && <i className="fas fa-check mr-1"></i>}
                        Em Aberto
                      </Button>
                      <Button
                        className="w-50 ml-1"
                        color={filterFinished ? "success" : "secondary"}
                        outline={!filterFinished}
                        size="sm"
                        onClick={() => toggleFilter("filterFinished")}
                      >
                        {filterFinished && <i className="fas fa-check mr-1"></i>}
                        Concluído
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody style={{ overflowX: "auto", minHeight: "10vh", padding: "0px" }}>
                {loading ? (
                  <center><Skeleton count={10} height={30} borderRadius="5px" inline /></center>
                ) : parsedTableData.length > 0 ? (
                  <ServiceDeskTable data={parsedTableData} />
                ) : (
                  <div className="text-center p-4">Nenhum dado encontrado para os filtros selecionados.</div>
                )}
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
      <Loading modalOpened={loading} />
    </>
  )
}